import {Text} from '@/components/atoms'
import {MuiTextField} from '@/components/atoms/MuiTextField/MuiTextField'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {DiscountReward, PromotionCondition, PromotionType, RewardType} from '@/types/promotion'
import {FC} from 'react'

type DiscountInputProps = {
  promotionCondition: PromotionCondition
  textAfterInput?: string
  showDynamicPlaceholder?: boolean
}

export const RewardDiscount: FC<DiscountInputProps> = ({
  promotionCondition,
  textAfterInput = '% off.',
  showDynamicPlaceholder = false,
}) => {
  const {updateCondition, promotionConfig, promotion} = usePromotion()
  const maxDiscountPercentage = promotionConfig?.maxDiscountPercentage || 0

  const {rewards} = promotionCondition
  const currentReward = rewards?.[0]
  const isDiscountReward = currentReward?.type === RewardType.DISCOUNT
  const currentRewardDiscountPercentage = isDiscountReward ? (currentReward as DiscountReward).discountValue : ''

  const updatePercentage = (value: string) => {
    updateCondition({
      ...promotionCondition,
      rewards: [
        {
          type: RewardType.DISCOUNT,
          discountType: 'PERCENTAGE',
          discountValue: Number(value),
        },
      ],
    })
  }

  const handleDiscountChange = event => {
    const value = event.target.value

    if (value === '') {
      updatePercentage(value)
      return
    }

    const decimalPart = value.split('.')[1]
    if (decimalPart && decimalPart.length > 4) {
      return
    }

    updatePercentage(value)
  }

  const placeholderText = showDynamicPlaceholder ? `Up to ${maxDiscountPercentage}%` : '0.0'
  const discountPercentage = currentRewardDiscountPercentage || ''

  // Don't show error for STORE_DISCOUNT and WELCOME_DISCOUNT promotion types
  const isError =
    promotion.promotionType !== PromotionType.STORE_DISCOUNT &&
    promotion.promotionType !== PromotionType.WELCOME_DISCOUNT &&
    discountPercentage > maxDiscountPercentage

  return (
    <>
      <MuiTextField
        type="number"
        onChange={handleDiscountChange}
        placeholder={placeholderText}
        value={discountPercentage.toString().replace(',', '.')} // Ensure value is a string and replace comma with dot
        inputProps={{
          inputMode: 'decimal',
          lang: 'en-US',
          step: 'any',
          min: '0',
        }}
        error={isError}
        className={isError ? 'rounded-md border border-solid border-red-350 outline-none focus:border-red-350' : ''}
        style={{maxWidth: '160px'}}
      />
      <Text>{textAfterInput}</Text>
    </>
  )
}
